<template>
  <div :style="colorbackground" class="container-fluid register">
    <div class="container">
      <div class="row">

        <div class="col-lg-4  col-10 col-sm-8 m-auto login-form">
          <router-link to="/" class="content-logo-principal">
           <div style="display:flex;justify-content:center;align-items:center">
              <h1 class="logo-name style-scope page-auth-login">
                <a href="https://royalpag.com/">
                       <img :src="img" style="width: 250px">
                </a></h1>
            </div>
          </router-link>
          <h2 class="text-center text-default-gray logo_h2" style="font-size: 16px; font-family: Roboto;">
            Crie sua conta agora!
          </h2>
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <form class="well" @submit.prevent="submit">
                  <div class="form-group">
                    <input placeholder="Nome Completo" type="text" class="form-control here" :class="{ invalid: $v.usuario.nome.$error }" @input="$v.usuario.nome.$touch()" v-model="usuario.nome" autofocus>
                    <span v-if="$v.usuario.nome.$dirty && !$v.usuario.nome.required" class="invalid">Campo obrigatório!</span>
                    <span v-if="$v.usuario.nome.required && !$v.usuario.nome.minLength" class="invalid">Senha mínimo {{$v.usuario.nome.$params.minLength.min}} caracteres</span>
                  </div>
                   <div class="form-group">                      
                    <multiselect @select="updateDocumentType" v-model="usuario.tipoDeDocumento" :options="tiposDeDocumentos" :searchable="false" :allow-empty="false" :show-labels="false" placeholder="Selecione o tipo de documento!"></multiselect>   
                  </div>                  
                  <div class="form-group" v-if="usuario.tipoDeDocumento === 'CPF' ">
                      <input :class="{ invalid: $v.usuario.cpf.$error }" @input="$v.usuario.cpf.$touch()" v-model="usuario.cpf" placeholder="INFORME SEU CPF" type="text" v-mask="'###.###.###-##'" class="form-control" v-on:blur="validate('cpf', usuario.cpf)" autofocus>
                      <span v-if="$v.usuario.cpf.$dirty && !$v.usuario.cpf.required" class="invalid">Campo obrigatório!</span>
                      <span v-if="$v.usuario.cpf.required && !$v.usuario.cpf.minLength" class="invalid">O CPF deve ter pelo menos {{ $v.usuario.cpf.$params.minLength.min }} caracteres!</span>
                      <span v-if="$v.usuario.cpf.required && $v.usuario.cpf.minLength && !$v.usuario.cpf.isCheckCPF" class="invalid">CPF não é válido.</span>
                      <span v-if="$v.usuario.cpf.$dirty && exist.cpf" class="invalid">CPF já cadastrado no sistema!</span>
                  </div>
				  <div class="form-group" v-if="usuario.tipoDeDocumento === 'NIF' ">
                      <input :class="{ invalid: $v.usuario.nif.$error }"  @input="$v.usuario.nif.$touch()" v-model="usuario.nif" placeholder="INFORME O NIF" type="text" v-mask="['XXXXXXXXXX']" class="form-control here" v-on:blur="validate('cpf', usuario.nif)" autofocus>
                      <span v-if="$v.usuario.nif.$dirty && !$v.usuario.nif.required" class="invalid">Campo obrigatório!</span>
                      <span v-if="$v.usuario.nif.required && !$v.usuario.nif.minLength" class="invalid">O NIF deve ter pelo menos {{ $v.usuario.nif.$params.minLength.min }} caracteres!</span>                      
                      <span v-if="$v.usuario.nif.$dirty && exist.cpf" class="invalid">NIF já cadastrado no sistema!</span>
                  </div>
                  <div class="form-group" v-if="usuario.tipoDeDocumento === 'PASSAPORTE' ">
                      <input :class="{ invalid: $v.usuario.passaporte.$error }" @input="$v.usuario.passaporte.$touch()" v-model="usuario.passaporte" placeholder="INFORME O PASSAPORTE" v-mask="['AX#########']" type="text" class="form-control here" v-on:blur="validate('cpf', usuario.passaporte)" autofocus>
                      <span v-if="$v.usuario.passaporte.$dirty && !$v.usuario.passaporte.required" class="invalid">Campo obrigatório!</span>
                      <span v-if="$v.usuario.passaporte.required && !$v.usuario.passaporte.minLength" class="invalid">O PASSAPORTE deve ter pelo menos {{ $v.usuario.nif.$params.minLength.min }} caracteres!</span>                      
                      <span v-if="$v.usuario.passaporte.$dirty && exist.cpf" class="invalid">PASSAPORTE já cadastrado no sistema!</span>
                  </div>				  
                  <div class="form-group">
                    <input placeholder="E-mail" type="email" autocomplete="username" class="form-control here" :class="{ invalid: $v.usuario.email.$error }" @input="$v.usuario.email.$touch()" v-model="usuario.email" v-on:blur="validate('email', usuario.email)">
                    <span v-if="$v.usuario.email.$dirty && !$v.usuario.email.required" class="invalid">Campo obrigatório!</span>
                    <span v-if="!$v.usuario.email.email" class="invalid">Email inválido!</span>
                    <span v-if="$v.usuario.email.$dirty && exist.email" class="invalid">E-mail já cadastrado no sistema!</span>
                  </div>				  
				  <div class="form-group">																	
					<div class="input-group">
						<input id="dataNascimento" type="text" v-model="usuario.dataNascimento" v-mask="'##/##/####'" class="form-control" :class="{ invalid: $v.usuario.dataNascimento.$error }" @input="$v.usuario.dataNascimento.$touch()" aria-describedby="dataNascimento" placeholder="Informe sua data de nascimento">
					 </div>
				  </div>
          <div class="form-group">
            <input placeholder="Senha" type="password" autocomplete="new-password" class="form-control here" :class="{ invalid: $v.usuario.senha.$error }" @input="$v.usuario.senha.$touch()" v-model="usuario.senha">
            <span v-if="$v.usuario.senha.$dirty && !$v.usuario.senha.required" class="invalid">Campo obrigatório!</span>
            <span v-if="$v.usuario.senha.required && !$v.usuario.senha.minLength" class="invalid">Senha mínimo {{$v.usuario.senha.$params.minLength.min}} caracteres</span>
          </div>

          <div class="form-group" v-if="usuario.tipoDeDocumento == 'CPF'">
            <input :class="{ invalid: $v.usuario.telefone.$dirty && $v.usuario.telefone.$invalid }" @input="$v.usuario.telefone.$touch()" v-mask="['(##) #####-####']" v-model="usuario.telefone" placeholder="Celular" type="text" class="form-control" v-on:blur="validate('telefone', usuario.telefone)" autofocus>
            <span v-if="$v.usuario.telefone.$dirty && !$v.usuario.telefone.required" class="invalid">Campo obrigatório!</span>
            <span v-if="$v.usuario.telefone.$dirty && exist.telefone" class="invalid">Número já cadastrado no sistema!</span>
          </div>
				  <div class="form-group" v-else>
            <vue-phone-number-input v-model="usuario.telefone" :preferred-countries="['BR','US','PT']" size="sm" :default-country-code="'BR'" :ignored-countries="['BR']" :translations="translations" maxlength="15" @update="onUpdate"></vue-phone-number-input>
                    <span v-if="$v.usuario.telefone.$dirty && !$v.usuario.telefone.required" class="invalid">Campo obrigatório!</span>
                    <span v-if="exist.telefone" class="invalid">Número já cadastrado no sistema!</span>
					          <span v-if="$v.usuario.telefone.$isValid" class="invalid">Dados do celular inválidos!</span>
                  </div>
                  <div class="col-12">
                    <div class="form-group checkbox">
                      <label for="termos">
                        <input type="checkbox" v-model="termos" :class="{ invalid: $v.termos.$error }" @input="$v.termos.$touch()" name="termos" id="termos">&nbsp;
                          <a target="my-modal">Eu aceito os </a>
                      </label>
                    <a @click="showModal" target="my-modal"><strong style="text-decoration:underline">Termos &amp; Condições.</strong></a>
                    <span v-if="$v.termos.$dirty && !$v.termos.required" class="invalid">Favor marcar campo de aceite dos termos!</span>
                    </div>

                  </div>
                  <div class="form-group">	
                      <input type="submit" value="Cadastrar" :style="color" class="btn btn-primary btn-block" v-if="usuario.tipoDeDocumento === 'CPF'" />
                      <input type="submit" value="Cadastrar" :style="color" class="btn btn-primary btn-block" v-else/>
                  </div>
                  <span class="sign-in" style="color: gray;">Já é um membro?  <router-link to="/auth/login" style="padding-left:20px">Entrar</router-link></span>
                </form>
              </div> <!-- col-12 -->
            </div><!-- row -->
              <div>

                  <b-modal scrollable size="xl" ref="my-modal" hide-footer title="Termos e condições">
                    <b-embed
                    type="iframe"
                    embed-responsive-4by3
                    src="./static/pdfs/termo.pdf"
                    allowfullscreen
                  ></b-embed>

                  </b-modal>
              </div>
          </div><!-- card-body -->
        </div><!-- login-form -->
      </div><!-- row pai -->
    </div><!-- container -->
  </div><!-- .register class -->
</template>
<script src="https://unpkg.com/vue-tel-input"></script>
<script>
  // import http from '@/service/http'
  import localforage from 'localforage'
  import { required, email, minLength } from 'vuelidate/lib/validators'
  import { mapActions, mapState } from 'vuex'
  import Multiselect from 'vue-multiselect'
  import '@fengyuanchen/datepicker/dist/datepicker.css'
  import '@fengyuanchen/datepicker/dist/datepicker.js'
  import site_style from '@/service/site_style'

  export default {
    name: 'Register',
    components: {
      Multiselect
    },
    data () {
      return {
        img: site_style.getLogo().default,
        color: site_style.getColor(),
        colorbackground: site_style.  getColorBackGround(),
        translations: {
          countrySelectorLabel: 'Selecione um País',
          example: 'Exemplo :',
          countrySelectorError: 'País invalido',
          phoneNumberLabel: 'Celular (para envio de sms)'
        },
        jsonInputTelefone: { },
        perfisSelecionadas: [],
        tipoUsuarioSelecionado: null,
        indicacao: {
          identificador: '',
          requisicoes: 0,
          registros: 0,
          idUsuario: 0
        },
        usuario: {
          id: 0,
          nome: '',
          email: '',
          login: '',
          senha: '',
          cpf: '',
          nif: '',
          passaporte: '',
          telefone: '',
          idTipoUsuario: 0,
          descricaoTipoUsuario: '',
          perfisId: [],
          tipoDeDocumento: 'CPF',
          dataNascimento: ''
        },
        // senha_verificacao: '',
        termos: false,
        tipoDeDocumentoSelecionado: null,
        tiposDeDocumentos: ['CPF']
      }
    },
    validations: {
      usuario: {
        nome: {
          required,
          minLength: minLength(4)
        },
        email: {
          required,
          email
        },
        tipoDeDocumento: {
          required
        },
        cpf: {
          required,
          minLength: minLength(14),
          isCheckCPF (cpf) {
            return this.$cpfCnpj.validaCpf(cpf)
          }
          // async isUnique (v) {
          //   const object = 'cpf'
          //   const value = v
          //   const feature = 'usuarios'
          //   const verb = 'post'
          //   const id = 0
          //   if (this.usuario.tipoDeDocumento === 'CPF') {
          //     console.log('validando cpf')
          //     return this.isUnique({object, value, feature, verb, id})
          //   }
          // }
        },
        nif: {
          required,
          minLength: minLength(8)
          // async isUnique (v) {
          //   const object = 'nif'
          //   const value = v
          //   const feature = 'usuarios'
          //   const verb = 'post'
          //   const id = 0
          //   if (this.usuario.tipoDeDocumento === 'NIF') {
          //     return this.isUnique({object, value, feature, verb, id})
          //   }
          //   return true
          // }
        },
        passaporte: {
          required,
          minLength: minLength(8)
          // async isUnique (v) {
          //   const object = 'passaporte'
          //   const value = v
          //   const feature = 'usuarios'
          //   const verb = 'post'
          //   const id = 0
          //   if (this.usuario.tipoDeDocumento === 'PASSAPORTE') {
          //     return this.isUnique({object, value, feature, verb, id})
          //   }
          //   return true
          // }
        },
        telefone: {
          required
          // async isUnique (v) {
          //   const object = 'telefone'
          //   const value = v
          //   const feature = 'usuarios'
          //   const verb = 'post'
          //   const id = 0
          //   return this.isUnique({object, value, feature, verb, id})
          // }
        },
        dataNascimento: {
          required,
          isValidDate (date) { return this.$moment(date, 'DD/MM/YYYY').isValid() }
        },
        senha: {
          required,
          minLength: minLength(6)
        }
      },
      termos: {
        required
      }
    },
    computed: {
      ...mapState('usuarios', ['exist']),
      ...mapState('perfis', {
        perfis (state) {
          return this.orderBy(state.list, 'nome', 1)
        }
      }),
      ...mapState('tiposUsuarios', {
        tiposUsuarios (state) {
          return state.list
        }
      }),
      ...mapState(['logo']),
      isWholeModelValid () {
        console.log(this.$v.$invalid)
        return !this.$v.$invalid
      }
    },
    methods: {
      ...mapActions(['isUnique']),
      ...mapActions('usuarios', ['saveRegistro', 'validateExists']),
      ...mapActions('auth', ['fetchOne']),
      ...mapActions('perfis', {
        fetchPerfis: 'fetch'
      }),
      ...mapActions('indicacoes', {
        saveIndicacao: 'save'
      }),
      ...mapActions('tiposUsuarios', {
        fetchTiposUsuarios: 'fetch'
      }),
      showModal () {
        this.$refs['my-modal'].show()
      },
      hideModal () {
        this.$refs['my-modal'].hide()
      },
      async saveRequest (identificador, tipo) {
        const verb = 'put'
        this.indicacao.identificador = identificador
        this.indicacao.requisicoes = tipo === 'requisicao' ? 1 : 0
        this.indicacao.registros = tipo === 'registro' ? 1 : 0
        const indicacao = Object.assign({}, this.indicacao)
        this.saveIndicacao({ verb, indicacao }).then(() => {
          console.log('request salvo com sucesso')
        })
      },
      setTipoUsuario () {
        this.tiposUsuarios.forEach((tu) => {
          if (tu.descricao === 'USUARIO_PF') {
            this.usuario.descricaoTipoUsuario = tu.descricao
            this.usuario.idTipoUsuario = tu.id
          }
        })
      },
      setPerfil () {
        this.perfis.forEach((perfil) => {
          if (perfil.nome === 'Cliente') {
            this.usuario.perfisId.push(perfil.id)
          }
        })
      },
      validate (field, value) {
        this.validateExists({
          field: field,
          value: value
        })
      },
      updateDocumentType (type) {
        this.usuario.cpf = ''
        this.usuario.nif = ''
        this.usuario.passaporte = ''
      },
      async submit () {
        if (this.$v.termos.$invalid) {
          this.$v.termos.$touch()
        } else {
          this.setPerfil()
          this.setTipoUsuario()
          let self = this
          this.usuario.login = this.usuario.email
          this.usuario.identificador = this.$route.query.identificador
          var telefoneValido = this.jsonInputTelefone['isValid']
          console.log('telefoneValido: ' + telefoneValido)
          const telefoneFormatInternational = this.jsonInputTelefone['formatInternational']
          const countryCode = this.jsonInputTelefone['countryCode']
          const nationalNumber = this.jsonInputTelefone['nationalNumber']
          const formattedNumber = this.jsonInputTelefone['formattedNumber']
          const verb = 'post'

          let identificador = await localforage.getItem('inviteId')
          // console.log(identificador)
          console.log(this.usuario.dataNascimento)
          var usuario = Object.assign({}, this.usuario)
          const dataNascimento = new Date(self.$moment(this.usuario.dataNascimento, 'DD/MM/YYYY'))
          console.log('dataNascimento date: ' + dataNascimento)
          if (dataNascimento !== 'Invalid Date') {
            usuario.dataNascimento = dataNascimento
          }
          if (telefoneFormatInternational !== undefined) {
            usuario.telefone = telefoneFormatInternational
          }
          if (countryCode !== undefined) {
            console.log('countryCode: ' + countryCode)
            usuario.paisTelefone = countryCode
          }
          if (nationalNumber !== undefined) {
            console.log('nationalNumber: ' + formattedNumber)
            usuario.codigoPaisTelefone = formattedNumber.replace(nationalNumber, '')
          }
          await this.saveRegistro({ verb, usuario }).then((message) => {
            if (message) {
              localforage.setItem(message.key, message.value)
            }
            // console.log('Save Ok')
            if (identificador) {
              const verb = 'put'
              this.indicacao.identificador = identificador
              this.indicacao.requisicoes = 0
              this.indicacao.registros = 1
              this.indicacao.idUsuario = this.usuario.id
              const indicacao = Object.assign({}, this.indicacao)
              this.saveIndicacao({ verb, indicacao }).then(() => {
                console.log('request salvo com sucesso')
              })
            }
            this.$router.push({ name: 'auth.verificacao' })
          })
        }
      },
      checkPasswords (pass) {
        return (pass === this.usuario.senha)
      },
      onUpdate (payload) {
        this.jsonInputTelefone = payload
        var keys = Object.keys(payload)
        console.log('keys: ' + keys)
        console.log(this.jsonInputTelefone['formatInternational'])
        this.validate('telefone', payload.formatInternational)
      }
    },
    mounted () {
      if (window.location.href.indexOf('?') !== -1) {
        if (this.$route.query && this.$route.query.identificador) {
          localforage.setItem('inviteId', this.$route.query.identificador)
          this.saveRequest(this.$route.query.identificador, 'requisicao')
        }
      }
      this.fetchPerfis()
      this.fetchTiposUsuarios()
    }
  }
</script>
<style src="../../assets/css/login.css" scoped></style>
<style scoped>
  .top25 {
    margin-top: 25px;
  }
  .register {
    padding-top: 3.5%;
    width: 100%;
    height:100vh;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    /* background: radial-gradient(ellipse at center, #5A93AF 0%, #004E74 100%); */
    background-color: #eee;
    overflow-y: auto;
  }
  label[for="terms"]{
    width: 100%;
  }
  .vue-phone-number-input .dots-text{
    color: '#212529'
  }
</style>



// WEBPACK FOOTER //
// index.vue?e368cd02